export default __webpack_public_path__ + "static/media/bg_mobile.73dd2d27.jpg";